import React from 'react';

// WhatsApp-style formatting for chat bubbles (WhatsApp / Instagram / Facebook): *bold*, _italic_, ~strike~,
// ```monospace``` and clickable links. Builds React elements only (no HTML strings), so nothing a customer
// types can inject markup. Like WhatsApp, a marker only counts at a word edge and with no space just inside it.

const MARKS = [
  ['*', (k, c) => <strong key={k}>{c}</strong>],
  ['_', (k, c) => <em key={k}>{c}</em>],
  ['~', (k, c) => <s key={k}>{c}</s>],
];
const URL_RE = /(https?:\/\/[^\s<]+[^\s<.,:;"')\]!?])/;
const EDGE = /[\s.,:;!?"'()[\]{}<>/\\-]/;

function inline(text, key) {
  const out = [];
  let buf = '';
  let i = 0;
  const flush = () => { if (buf) { out.push(buf); buf = ''; } };
  while (i < text.length) {
    const rest = text.slice(i);
    const url = rest.match(URL_RE);
    if (url && url.index === 0 && (i === 0 || EDGE.test(text[i - 1]))) {
      flush();
      out.push(<a key={`${key}-u${i}`} href={url[1]} target="_blank" rel="noreferrer noopener">{url[1]}</a>);
      i += url[1].length;
      continue;
    }
    const ch = text[i];
    const mark = MARKS.find(([m]) => ch === m);
    if (mark && (i === 0 || EDGE.test(text[i - 1])) && text[i + 1] && !/\s/.test(text[i + 1])) {
      const [m, wrap] = mark;
      // Closing marker on the same line, not preceded by a space, followed by an edge or the end
      let j = i + 1;
      let end = -1;
      while ((j = text.indexOf(m, j + 1)) !== -1) {
        if (text.slice(i + 1, j).includes('\n')) break;
        if (!/\s/.test(text[j - 1]) && (j + 1 >= text.length || EDGE.test(text[j + 1]))) { end = j; break; }
      }
      if (end > i + 1) {
        flush();
        out.push(wrap(`${key}-${m}${i}`, inline(text.slice(i + 1, end), `${key}-${i}`)));
        i = end + 1;
        continue;
      }
    }
    buf += text[i];
    i += 1;
  }
  flush();
  return out;
}

/** Formatted text for a chat bubble. */
export function WaText({ text }) {
  const s = String(text ?? '');
  if (!s) return null;
  // ```monospace``` blocks first (they can span lines), the rest formatted inline
  const parts = s.split(/(```[\s\S]+?```)/);
  return parts.map((p, n) => (p.startsWith('```') && p.endsWith('```') && p.length > 6
    ? <code key={`m${n}`} className="cx-wa-mono">{p.slice(3, -3)}</code>
    : <React.Fragment key={`t${n}`}>{inline(p, `p${n}`)}</React.Fragment>));
}

export default WaText;
